<script>
import ResourceService from '@/services/resources/subscriptions_service';
import SiteView from './SiteView.vue';

export default {
  extends: SiteView,
  components: {
    ActionBar: () => import('@/components/action_bars/SubscriptionsActionBar.vue'),
  },
  data() {
    return {
      resourceService: ResourceService,
      icon: 'mdi-email-send',
      urlFragment: 'email-reports',
      headers: [
        { text: 'Recipient', value: 'recipient' },
        { text: 'Report', value: 'typeName' },
        { text: 'Interval', value: 'interval' },
      ],
      sortBy: ['recipient'],
    };
  },
  computed: {
    resourceParams() {
      return {
        filter: {
          site: this.siteId,
        },
      };
    },
  },
};
</script>
